var btoa = require('btoa');
var fetch = require('isomorphic-fetch');
// WARN: certificate has expired error because of the fetch polyfill in the browser, so we need to use the fetch polyfill in the server
// to avoid the error and update node-fetch to the latest version, as well as node from v8.5 to v8.6
{
}

// Utility vars/functions for working with nestio, including a really simple
// cache so we don't have to go to nestio each time. We really shouldn't be
// implementing a cache ourselves, but I couldn't find anything off the shelf.
// Note: the cache key is just the uri; headers are not part of the key. Cache
// object format is {URI: {expires: Date, content: JSON body parsed, status: int}}
const nestioCache = {};
// const NESTIO_API_KEY = 'f8bfc72a13cf43f1ad38d0642b0fa23a';
const NESTIO_API_KEY = '0c44cf1104174061ad121134a3415451';
const NESTIO_AUTH_HEADER = makeBasicAuthHeader(NESTIO_API_KEY, '');
const FORMSPREE_ID = 'modwddax';
//Small change for build

function nestioProxyPost(requestUrl, body, extraHeaders = {}) {
  const requestBody = JSON.stringify(body);
  // console.log('request url', requestUrl, 'requestBody', requestBody);

  return fetch(requestUrl, {
    method: 'POST',
    // headers: Object.assign({
    //   'Accept': 'application/json',
    //   'Content-Type': 'application/json',
    //   'Authorization': NESTIO_AUTH_HEADER
    // }, extraHeaders),
    headers: {
      Authorization: NESTIO_AUTH_HEADER,
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: requestBody,
  }).then(
    (response) => {
      return response.json().then(
        (json) => {
          if (!response.ok) {
            console.error(
              'Nestio POST to ' + requestUrl + ' returned a non 2xx status',
              `request body was: ${requestBody}`,
              `response body was: ${JSON.stringify(json)}`,
              response
            );

            throw new Error(
              'Nestio POST to ' + requestUrl + 'returned a non 2xx status'
            );
          }
          console.log('nestio response', json);

          return { content: json, status: response.status };
        },
        (e) => {
          console.error(
            'error parsing nestio response as json',
            // requestUrl, body, response
            requestUrl,
            requestBody,
            response
          );
          throw e;
        }
      );
    },
    (e) => {
      throw new Error('Nestio POST to ' + requestUrl + 'did not go through', e);
    }
  );
}

function nestioFetchWithCache(
  requestUrl,
  headers,
  cacheTimeMs = 1000 * 60 * 10 /* 10 mins */
) {
  const publicFormatOfCacheEntry = (cacheEntry) => ({
    content: cacheEntry.content,
    status: cacheEntry.status,
  });

  if (nestioCache[requestUrl] && nestioCache[requestUrl].expires > Date.now()) {
    // console.log('serving ' + requestUrl + ' from cache');
    return Promise.resolve(publicFormatOfCacheEntry(nestioCache[requestUrl]));
  } else {
    // If there's a cache entry for requestUrl, remove it, as it's expired.
    delete nestioCache[requestUrl];
    const finalHeaders = Object.assign(headers, {
      Authorization: NESTIO_AUTH_HEADER,
    });

    return fetch(requestUrl, { headers: finalHeaders })
      .then((response) => {
        // Sometimes, a non 2xx status code is what we expect. (E.g., when we
        // fetch appointment times, we always use 11AM, which is an error if it's
        // in the past, but that error can be safely ignored and we can still
        // use the result.) Moreover, the response is certainly still cacheable.
        // So don't error and continue to parse the JSON. But do warn.
        if (!response.ok) {
          console.log(
            'WARN: Nestio request to ' +
              requestUrl +
              ' had status ' +
              response.status,
            response
          );
        }

        return response
          .json()
          .then((json) => {
            // I'm not going to reimplement all of HTTP caching, so we ignore
            // nestio's caching directives (if any) and cache for a fixed time.
            console.log('caching response for ' + requestUrl);
            nestioCache[requestUrl] = {
              expires: new Date(Date.now() + cacheTimeMs),
              content: json,
              status: response.status,
            };

            return publicFormatOfCacheEntry(nestioCache[requestUrl]);
          })
          .catch((e) => {
            console.log(
              'error parsing nestio response as json',
              requestUrl,
              e,
              response
            );
          });
      })
      .catch((e) => {
        console.log('error fetching from nestio', requestUrl, e);
      });
  }
}
function postToFormSpree(data) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    mode: 'cors',
    body: data,
  };

  try {
    fetch('https://formspree.io/modwddax', requestOptions)
      .then((response) => {
        console.log('response: ', response);
        return response.json();
      })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log('error: ', error);
      });
  } catch (error) {
    console.log('error: ', error);
  }
}

function makeBasicAuthHeader(user, pass) {
  return `Basic ${btoa(user + ':' + pass)}`;
}
function filterPrivateListings(items) {
  if (!items || items.length === 0) {
    return [];
  }
  const nonTTWRemoved = items.filter((listing) => {
    const unitName = listing.unitTypeName;
    const isPrivate = listing && listing.private;
    const privateAndTTW = isPrivate && unitName === 'TTW';
    return privateAndTTW || !isPrivate;
  });
  return nonTTWRemoved;
}

module.exports = {
  makeBasicAuthHeader,
  postToFormSpree,
  NESTIO_API_KEY,
  nestioFetchWithCache,
  nestioProxyPost,
  filterPrivateListings,
};



// WEBPACK FOOTER //
// ./server/util.js